export default __webpack_public_path__ + "static/media/aws.7f4f97c9.svg";